import { createStore } from 'effector';

import { Answers } from 'types/zod/answers';
import { EstatePlanProductChoice } from 'types/zod/product-choice';
import { Question } from 'types/zod/question';
import { QuestionnaireInstance } from 'types/zod/questionnaire-instance';

type QInstanceId = QuestionnaireInstance['questionnaire_instance_id'];

const $epQInstanceId = createStore<QInstanceId | null>(null);
const $epQuestionnaire = createStore<Question | null>(null);
const $epQInstance = createStore<QuestionnaireInstance | null>(null);
const $epAnswers = createStore<Answers | null>(null);
const $isSingle = createStore<boolean | null>(null);
const $selectedProduct = createStore<EstatePlanProductChoice | null>(null);
const $selectedProductIndex = createStore<number | null>(null);
const $productChoices = createStore<EstatePlanProductChoice[] | null>(null);
const $isCongratulationAnswersUpdated = createStore<boolean | null>(null);
const $congradulationPaths = createStore<Record<string, boolean> | null>(null);

const $$ep = {
    stores: { $epQInstanceId, $epQuestionnaire, $epQInstance, $epAnswers },
    $isSingle,
    $selectedProduct,
    $selectedProductIndex,
    $productChoices,
    $isCongratulationAnswersUpdated,
    $congradulationPaths,
};

export default $$ep;
